export default {
    modalPadding: '20px'
};
